<pages-container
  [title]="'main.forumStatistics'"
  [icon]="'analytics'">

  <div main-content class="banner-list statistics-grid">
    @if (statistics()) {
      <mat-card class="statistic-card">
        <mat-card-content>
          <div class="statistic-data">{{ 'statistics.orgsWithForumTalk' | translate }}
            : {{ statistics()?.org_count }}
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card class="statistic-card">
        <mat-card-content>
          <div class="statistic-data">{{ 'statistics.eventsWithChatroom' | translate }}
            : {{ statistics()?.event_count }}
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card class="statistic-card">
        <mat-card-content>
          <div class="statistic-data">{{ 'statistics.eLearningsWithChatroom' | translate }}
            : {{ statistics()?.event_count }}
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card class="statistic-card">
        <mat-card-content>
          <div class="statistic-data">{{ 'statistics.learningPathsWithChatroom' | translate }}
            : {{ statistics()?.learn_paths_count }}
          </div>
        </mat-card-content>
      </mat-card>
    }
    @if (chartData().length) {
      <div class="charts-grid">
        @for (chart of chartData(); track chart.name) {
          <div class="chart-card">
            <div class="chart-title">{{ chart.name | translate}}</div>
            <ngx-charts-bar-vertical
              [results]="chart.series"
              [scheme]="colorScheme"
              [xAxis]="true"
              [yAxis]="true"
              [legend]="false"
              [showXAxisLabel]="true"
              [showYAxisLabel]="false"
              [view]="[700, 250]"
              [animations]="true"
              [tooltipDisabled]="false"
              [showDataLabel]="true">
            </ngx-charts-bar-vertical>
          </div>
        }
      </div>
    }
    @if (!chartData().length) {
      <div class="no-data-msg">
        <span class="mat-headline-6">{{ 'main.noData' | translate }}</span>
      </div>
    }
  </div>
</pages-container>
